import React, { useCallback, useMemo } from 'react';
import { AppReviewPromptClient, AppReviewPromptEventType, RecordAppReviewPromptEventRequest } from '../api/api.g';
import AppReviewPromptPopup from '../components/common/appReview/AppReviewPromptPopup';
import { getAppReviewPromptPlatform } from '../helpers/appReviewPromptHelper';
import { lightBoxActions } from '../store/lightBoxSlice';
import useApi from './api-hook';
import { useAppDispatch } from './store-hook';

const useAppReviewPrompt = () => {
  const dispatch = useAppDispatch();
  const api = useApi(AppReviewPromptClient);
  const platform = useMemo(() => getAppReviewPromptPlatform(), []);

  const closeReviewPopup = useCallback(() => {
    dispatch(lightBoxActions.setVisibility(false));
    dispatch(lightBoxActions.setContent(<></>));
    dispatch(lightBoxActions.setOnClose(undefined));
    dispatch(lightBoxActions.setIsLoading(false));
    dispatch(lightBoxActions.setOverlayVisible(true));
    dispatch(lightBoxActions.setAllowBackgroundInteraction(false));
    dispatch(lightBoxActions.setNoDismiss(false));
    dispatch(lightBoxActions.setContentVerticalAlign('center'));
    dispatch(lightBoxActions.setContentHorizontalAlign('center'));
    dispatch(lightBoxActions.setContentTopOffset(0));
    dispatch(lightBoxActions.setContentBottomOffset(0));
    dispatch(lightBoxActions.setContentLeftOffset(0));
  }, [dispatch]);

  const checkAndShowAppReviewPrompt = useCallback(async () => {
    const eligibility = await api.getEligibility(api.tokenSource?.token).catch(() => undefined);

    if (!eligibility?.eligible || !eligibility.promptId) {
      return;
    }

    const promptId = eligibility.promptId;
    const dismissReviewPopup = async () => {
      await api
        .recordEvent(
          promptId,
          RecordAppReviewPromptEventRequest.fromJS({
            eventType: AppReviewPromptEventType.Dismissed,
            platform,
          }),
          api.tokenSource?.token,
        )
        .catch(() => undefined);
      closeReviewPopup();
    };

    dispatch(lightBoxActions.setIsLoading(false));
    dispatch(lightBoxActions.setOverlayVisible(true));
    dispatch(lightBoxActions.setAllowBackgroundInteraction(false));
    dispatch(lightBoxActions.setNoDismiss(false));
    dispatch(lightBoxActions.setContentVerticalAlign('center'));
    dispatch(lightBoxActions.setContentHorizontalAlign('center'));
    dispatch(lightBoxActions.setContentTopOffset(0));
    dispatch(lightBoxActions.setContentBottomOffset(0));
    dispatch(lightBoxActions.setContentLeftOffset(0));
    dispatch(lightBoxActions.setOnClose(dismissReviewPopup));
    dispatch(lightBoxActions.setContent(<AppReviewPromptPopup promptId={promptId} onClose={closeReviewPopup} />));
    dispatch(lightBoxActions.setVisibility(true));
  }, [api, closeReviewPopup, dispatch, platform]);

  return {
    checkAndShowAppReviewPrompt,
  };
};

export default useAppReviewPrompt;
